import { __assign, __rest } from "tslib";
import UAParser from 'my-ua-parser';
import { convertObjectUndefinedNull } from '../../../lib/utils';
import whereami from '../../../utils/whereami';
/**
 * we decide to only map the two main Platforms
 * iOS for apple vendor device (watch, macintosh, cellphone)
 * or otherwise, it's a Android.
 */
export var PlatformEnum;
(function (PlatformEnum) {
    PlatformEnum["iOs"] = "iOS";
    PlatformEnum["Android"] = "Android";
})(PlatformEnum || (PlatformEnum = {}));
export var getDeviceInfo = function (headers, routeInfo) {
    if (headers === void 0) { headers = {}; }
    var getPlatform = function (vendor) {
        /**
         * return null in common web application
         * to avoid misuse, when receiving "Android" in Linux/Windows notebooks.
         */
        if (!(routeInfo === null || routeInfo === void 0 ? void 0 : routeInfo.isMiniApp))
            return null;
        /**
         * for the future, if another platform, just add the new Vendor here
         */
        var VendorMap = {
            Apple: PlatformEnum.iOs,
        };
        return (VendorMap[vendor] ||
            PlatformEnum.Android);
    };
    if (whereami.isClientSide) {
        var _a = new UAParser(navigator.userAgent).getResult(), device_1 = _a.device, info = __rest(_a, ["device"]);
        var platform_1 = getPlatform(device_1.vendor);
        return convertObjectUndefinedNull(__assign(__assign(__assign({}, info), device_1), { platform: platform_1 }));
    }
    var _b = new UAParser(headers['user-agent'] || '').getResult(), device = _b.device, serverDevice = __rest(_b, ["device"]);
    var platform = getPlatform(device.vendor);
    return convertObjectUndefinedNull(__assign(__assign(__assign({}, device), serverDevice), { platform: platform }));
};
//# sourceMappingURL=getDeviceInfo.js.map